import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

import { ApiService } from './api.service'

@Injectable({
  providedIn: 'root'
})
export class EligibilitySearchService {

  constructor(private api: ApiService) { }

  public eligibilityFilter(data: any): Observable<any> {
    return this.api.post('v3/eligibility/filter', data)
  }

  public credentialFilter(data: any): Observable<any> {
    return this.api.post('v3/eligibility/credentials/filter', data)
  }

  public commandFilter(data: any): Observable<any> {
    return this.api.post('v3/eligibility/admin', { index: 'commands', body: data })
  }

  public taskFilter(data: any): Observable<any> {
    return this.api.post('v3/eligibility/admin', { index: 'background_tasks', body: data })
  }
}
